import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import config from './Config';

const AutoLogout = () => { 
    
    const INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 10 minutes in milliseconds

    const navigate = useNavigate()

    useEffect(() => {
        let inactivityTimer;

        // Function to reset the inactivity timer
        const resetInactivityTimer = () => {
            clearTimeout(inactivityTimer);
            inactivityTimer = setTimeout(() => {
                logoutUser();
            }, INACTIVITY_TIMEOUT); // Set timeout for auto logout after 15 minutes
        };

        // Function to handle the logout action
        const logoutUser = () => {
            secureLocalStorage.removeItem("credentials") 
            navigate(`${config.appUrl}login`)   
        };

        // Add event listeners to reset timer on activity
        window.addEventListener('mousemove', resetInactivityTimer);
        window.addEventListener('keydown', resetInactivityTimer);

        // Check if the user is logged in on mount
        if (secureLocalStorage.getItem("credentials")) {
            resetInactivityTimer();
        } 

        // Cleanup event listeners when the component is unmounted
        return () => {
            clearTimeout(inactivityTimer);
            window.removeEventListener('mousemove', resetInactivityTimer);
            window.removeEventListener('keydown', resetInactivityTimer);
        };
    }, []);

    return (
        <></>
    );
};

export default AutoLogout;
